import * as React from 'react';
import ReactDOM from 'react-dom';
import styles from './index.less';
import { MicroApp } from 'umi';
// import { initGlobalState, MicroAppStateActions } from 'qiankun';
import * as AHooks from 'ahooks';
import { getMicroAppName } from '@/constants';
import MicroAppStateActionsMgr from '@/utils/MicroAppStateActionsMgr';

interface FMicroApp_ResourceToNodeAuth_Props {
  nodeID?: number;
  onClose?: () => void;
}

function FMicroApp_ResourceToNodeAuth({ nodeID, onClose }: FMicroApp_ResourceToNodeAuth_Props) {
  AHooks.useMount(() => {
    MicroAppStateActionsMgr.actions.onGlobalStateChange((state: any, prev: any) => {
      if (state.authProcessorShow === false) {
        setTimeout(() => {
          onClose?.();
        }, 200);
      }
    }, false);
  });

  return ReactDOM.createPortal(
    <MicroApp
      name={
        getMicroAppName('ResourceSignNode')
      }
      licenseeId={nodeID}
      mainAppType={'resourceInExhibit'}
      // mainAppFuncs={{
      //   signedToNode({ presentableId, nodeId }: any) {
      //     // signedToNode?.(presentableId, nodeId);
      //     onSuccess?.({ exhibtID: presentableId, nodeID: nodeId });
      //   },
      // }}
    />,
    self.document.body,
  );
}

export default FMicroApp_ResourceToNodeAuth;

interface IState {
  authProcessorShow: boolean;
  licensorId: string;
}

export function setState_FMicroApp_ResourceToNodeAuth(state: Partial<IState>) {
  MicroAppStateActionsMgr.setState(state);
}
